import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import classNames from 'classnames';
import { isEmpty, uniq } from 'lodash';

import { PageWrapper, ErrorText, Loader, Alert, ImageSelector, ProductSearchModal } from '../../components';
import Actions, { thunks } from '../../redux/modules/products';
import { TOTAL_IMAGE_NUM, INDEX_TO_NAME } from '../../constants';
import ImagePlaceholder from '../../assets/img/img_placeholder.jpg';


class AddAdmin extends Component {
    state = {
        name: '',
        description: '',
        products: [],
        images: [...Array(TOTAL_IMAGE_NUM)],
        numImages: 0,
        errors: {},
        showModal: false,
    }


    onHandleInput = e => {
        const { target : { name, value } } = e
        this.setState({
            [name]: value,
            errors: {
                [name]: ''
            }
        })
    }

    onChangeImage = (e, index) => {
        const { images, numImages, errors } = this.state;
        images[index] = e.target.files[0];
        this.setState({ images, numImages: numImages + 1, errors: { ...errors, images: '' } });
    }

    onSave = e => {
        e.preventDefault();

        if (!this.validateForm()) return

        const { description, products, images, name } = this.state;
        const body = new FormData();
        body.append('name', name);
        body.append('description', description);
        images.map((image, index) => image ? body.append(`image${INDEX_TO_NAME[index][0].toUpperCase() + INDEX_TO_NAME[index].substr(1)}`, image) : '')
        body.append('productIds', uniq(products.map(product => product.productId)).join(','))

        this.props.dispatch(thunks.combineProducts(body, this.props.history))
    }


    validateForm = () => {
        const { description, products, images, name } = this.state;
        const errors = {};

        if (!name) errors.name = 'Required';
        if (!description) errors.description = 'Required';
        if (!products.length) errors.products = 'Required';
        if (!images[0]) errors.images = 'Atleast one image is required';

        this.setState({ errors });

        return isEmpty(errors);
    }

    toggleProductSearch = () => {
        this.setState(state => ({
            showModal: !state.showModal,
        }))
    }

    onSelectProduct = product => {
        const { products } = this.state;
        products.push(product)
        this.setState(state => ({
            products,
            showModal: false,
            errors: {
                ...state.errors,
                products: '',
            }
        }))
    }

    removeProduct = product => {
        const { products } = this.state;
        this.setState({
            products: products.filter(p => p.productId !== product.productId )
        })
    }

    onClose = () => {
        const { updateProperty, success } = this.props;
        updateProperty('error', '');
        if (success) this.onBack();
    }

    onBack = () => {
        this.props.history.push('/products')
    }

    render() {
        const { loading, error } = this.props;
        const { description, products, images, numImages, errors, showModal, name } = this.state;

        return (
            <PageWrapper title="Combine Products">
                <Loader show={loading}/>
                <Alert
                    show={!!error}
                    onHide={this.onClose}
                    title="Combine Products"
                    message={error}
                />
                <div className="row mt-3">
                    <div className="col-lg-12">
                        <div className="card">
                            <div className="card-header">
                                Combine Products
                            </div>
                            <div className="card-block">
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="form-group">
                                            <label className={classNames({ 'text-danger': errors.name })}>Name</label>
                                            <input
                                                type="text"
                                                name="name"
                                                value={name}
                                                maxLength="100"
                                                onChange={this.onHandleInput}
                                                className={classNames('form-control', { 'is-invalid': errors.name })}
                                                placeholder="Name"
                                            />
                                            <ErrorText error={errors.name}/>
                                        </div>
                                    </div>
                                    <div className="col-md-12">
                                        <div className="form-group">
                                            <label className={classNames({ 'text-danger': errors.description })}>Description</label>
                                            <textarea
                                                name="description"
                                                value={description}
                                                maxLength="500"
                                                onChange={this.onHandleInput}
                                                className={classNames('form-control', { 'is-invalid': errors.description })}
                                                placeholder="Description"
                                                rows="4"
                                            />
                                            <ErrorText error={errors.description}/>
                                        </div>
                                    </div>
                                    <div className="col-md-12 mb-2">
                                        <h4>Products</h4>
                                    </div>
                                    {products.map(product => (
                                        <div key={product.productId} className="col-md-3">
                                            <div className="d-flex">
                                                {<img src={product.productImages.length ? product.productImages[0] : ImagePlaceholder} alt={product.title} width="80px"/>}    
                                                <div className="flex-1 d-flex align-items-center">
                                                    <p className="ml-2">{product.title}</p>
                                                </div>
                                                <div className="center-item">
                                                    <button className="btn btn-danger" onClick={() => this.removeProduct(product)}>
                                                        <i className="fa fa-trash"/>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                    <div className="col-md-3">
                                        <button className="btn btn-primary mt-2" onClick={this.toggleProductSearch}>
                                            Add Product
                                        </button>
                                        <ProductSearchModal 
                                            show={showModal}
                                            onHide={this.toggleProductSearch}
                                            onSelect={this.onSelectProduct}
                                        />
                                        <p>
                                            <ErrorText error={errors.products}/>
                                        </p>
                                    </div>
                                    <div className="col-md-12 d-flex align-items-center mt-3">
                                        <h4>Images</h4>
                                        <small className="ml-2">(Max. 6 images can be uploaded)</small>
                                    </div>
                                </div>
                                <div className="d-flex mt-2 pb-3 overflow-x-scroll">
                                    {images.map((image, index) => (
                                        <ImageSelector
                                            src={image}
                                            onChangeImage={e => this.onChangeImage(e, index)}
                                            key={index}
                                            showButton={numImages === index}
                                        />
                                    ))}
                                </div>
                                <div className="ml-3">
                                    <ErrorText error={errors.images}/>
                                </div>
                                <div className="col-md-12 d-flex justify-content-end mt-2">
                                    <button className="btn btn-info" onClick={this.onBack}>
                                        Back
                                    </button>
                                    <button className="btn btn-primary ml-2" onClick={this.onSave}>
                                        Save
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </PageWrapper>
        )
    }
}

const mapStateToProps = ({
    products: {
        loading,
        error,
        success,
    },
}) => ({
    loading,
    error,
    success,
});

const mapDispatchToProps = dispatch => ({
    dispatch,
    updateProperty: bindActionCreators(Actions, dispatch).updateProperty,
    reset: bindActionCreators(Actions, dispatch).reset,
});

export default connect(mapStateToProps, mapDispatchToProps)(AddAdmin)